import {CameraVideoTrackInitConfig, LowStreamParameter, MicrophoneAudioTrackInitConfig} from "agora-rtc-sdk-ng";
import {AgoraVideoEncoding} from "@share/web-conferences/enums/AgoraVideoEncoding";
import {AgoraOptimizationModes} from "@share/web-conferences/enums/AgoraOptimizationMotions";
import {AgoraAudioEncoding} from "@share/web-conferences/enums/AgoraAudioEncoding";

export const videoTopQualityEncoding = AgoraVideoEncoding.Ve480p1;

const video480: CameraVideoTrackInitConfig = {
    encoderConfig: videoTopQualityEncoding,
    optimizationMode: AgoraOptimizationModes.Motion,
};


export const videoLowQualityEncoding = AgoraVideoEncoding.Ve120p1;

const audioTrackDefault: MicrophoneAudioTrackInitConfig = {
    encoderConfig: AgoraAudioEncoding.MusicStandard,
    AEC: true,
    AGC: true,
    ANS: true
}

const lowStreamParams: LowStreamParameter = {
    width: 160,
    height: 120,
    framerate: 15,
    bitrate: 65,
}

const retryConfig = {
    timeout: 10000,
    timeoutFactor: 1,
    maxRetryCount: 3,
    maxRetryTimeout: 1,
}

export {
    video480, audioTrackDefault, lowStreamParams, retryConfig
}
